import React from "react";
import { Lock, MapPin, Paperclip, CalendarDays } from "lucide-react";
import { fileUrl } from "@/lib/api";

const day = (v) => (v ? new Date(v).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const Row = ({ label, children, testid }) => (
  <div className="flex gap-3 py-1.5 text-sm min-w-0" data-testid={testid}>
    <span className="w-28 flex-shrink-0 text-slate-500">{label}</span><span className="min-w-0 break-words text-slate-900 font-medium">{children}</span>
  </div>
);

// Owner-only submitted details on the ad page; the backend sends `owner_details` only to the ad's own vendor.
export function OwnerAdDetails({ d, title, message, areas, files }) {
  const pinText = (areas?.length ? areas : d.pincodes.map((p) => ({ pincode: p })))
    .map((a) => [a.pincode, a.area, a.city].filter(Boolean).join(" ")).join(" · ");
  return (
    <div className="mt-4 bg-white border border-amber-200 rounded-3xl p-5 sm:p-7" data-testid="ad-owner-details">
      <div className="flex items-center gap-2 text-amber-900 font-bold text-sm"><Lock className="w-4 h-4" /> Sirf aapko dikhta hai — customers ko nahi</div>
      <div className="mt-3 divide-y divide-slate-100">
        <Row label="Status" testid="ad-owner-d-status">{(d.status || "").replace(/_/g, " ")}</Row>
        {d.admin_note && <Row label="Reject reason" testid="ad-owner-d-note"><span className="text-rose-700">{d.admin_note}</span></Row>}
        <Row label="Promote kiya" testid="ad-owner-d-target">{d.target_name || "—"} ({d.target_type})</Row>
        <Row label="Title" testid="ad-owner-d-title">{title || "—"}</Row>
        <Row label="Message" testid="ad-owner-d-message"><span className="whitespace-pre-line">{message || "—"}</span></Row>
        <Row label="PIN / area" testid="ad-owner-d-pins"><span className="inline-flex gap-1"><MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-emerald-700" />{pinText || "—"}</span></Row>
        <Row label="Duration" testid="ad-owner-d-duration">{d.duration_days ? `${d.duration_days} din` : "—"} · {d.free ? "Free" : `₹${d.price ?? 0}${d.paid ? " (paid)" : ""}`}</Row>
        <Row label="Start / End" testid="ad-owner-d-dates"><span className="inline-flex gap-1"><CalendarDays className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-emerald-700" />{day(d.starts_at)} → {day(d.ends_at)}</span></Row>
        <Row label="Submit kiya" testid="ad-owner-d-created">{day(d.created_at)}</Row>
        <Row label="Files" testid="ad-owner-d-files">
          {files?.length ? <span className="flex flex-wrap gap-1.5">{files.map((f) => (
            <a key={f.file_id} href={fileUrl(f.url)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 max-w-full rounded-full border border-slate-200 px-2 py-0.5 text-xs text-slate-700 hover:border-emerald-400" data-testid={`ad-owner-file-${f.file_id}`}>
              <Paperclip className="w-3 h-3 flex-shrink-0" /><span className="truncate">{f.filename}</span></a>))}</span> : "Koi file nahi"}
        </Row>
      </div>
    </div>
  );
}
